import Image from '../images/values.jpg'
import SectionHead from './SectionHead'
import {GiCutDiamond} from 'react-icons/gi'
import {values} from '../data'
import Card from '../UI/Card'
function Values() {
  return (
    <section className = 'values'>
      <div className="container values_container">
         <div className="values_left">
             <div className="value_image">
             <img src={Image} alt="" />

             </div>
                   
          </div> 
             
          <div className="values_right">
          <SectionHead icon={<GiCutDiamond />} title='Values'/>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quae mollitia aperiam voluptate, commodi nobis officia praesentium dolore? 
            Suscipit, natus sequi.
          </p>
          <div className="values_wraper">

          {
           
                  values.map(({id,icon,title,desc})=>{
                            
                    return (
                      <Card key={id}  className="values_value">
                        <span>{icon}</span>
                        <h4>{title}</h4>
                        <small>{desc}</small>

                                    
                      </Card>
                    )



                  })

          }


          </div>
          
          
          </div>     



      </div>
    

      
    </section>
  )
}

export default Values
